(function () {
  'use strict';

  function isArabicPage() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var path = location.pathname || '';
    return lang.indexOf('ar') === 0 || document.documentElement.dir === 'rtl' || /^\/ar(\/|$)/.test(path);
  }

  function getLabel() {
    if (isArabicPage()) {
      if (window.__BUY_NOW_AR) return String(window.__BUY_NOW_AR);
      return String.fromCharCode(0x0627, 0x0634, 0x062a, 0x0631, 0x0020, 0x0627, 0x0644, 0x0622, 0x0646);
    }
    return window.__BUY_NOW_EN ? String(window.__BUY_NOW_EN) : 'Buy Now';
  }

  function paintShadowLabel(shadow, label, arabic) {
    shadow.innerHTML =
      '<style>' +
      ':host{position:absolute;inset:0;display:block;pointer-events:none;}' +
      '.lbl{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;' +
      'font-size:14px;line-height:1.2;color:#000;font-weight:400;' +
      (arabic ? "font-family:'Noto Kufi Arabic',sans-serif;letter-spacing:0;" : 'letter-spacing:.07rem;') +
      '}</style><span class="lbl"></span>';
    var lbl = shadow.querySelector('.lbl');
    if (lbl) lbl.textContent = label;
  }

  function ensureBuyNowLabel(btn) {
    if (!btn || btn.tagName !== 'BUTTON') return;

    var label = getLabel();
    var arabic = isArabicPage();

    btn.classList.add('buy-now-fixed');
    if (arabic) btn.classList.add('buy-now-ar');
    else btn.classList.remove('buy-now-ar');

    btn.style.position = 'relative';
    btn.style.color = 'transparent';
    btn.style.fontSize = '0';
    btn.style.lineHeight = '0';
    btn.setAttribute('translate', 'no');
    btn.setAttribute('data-langify', '0');

    Array.prototype.slice.call(btn.childNodes).forEach(function (node) {
      if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.classList &&
        node.classList.contains('buy-now-label')
      ) {
        node.parentNode.removeChild(node);
      }
    });

    var host = btn.querySelector(':scope > .buy-now-shadow-host');
    if (!host) {
      host = document.createElement('span');
      host.className = 'buy-now-shadow-host';
      host.setAttribute('aria-hidden', 'true');
      host.setAttribute('translate', 'no');
      host.style.cssText = 'position:absolute;inset:0;display:block;pointer-events:none;z-index:5;';
      btn.appendChild(host);
    }

    if (!host.__buyNowShadow) {
      try {
        host.__buyNowShadow = host.attachShadow({ mode: 'open' });
      } catch (e) {
        host.__buyNowShadow = null;
      }
    }

    if (host.__buyNowShadow) {
      var existing = host.__buyNowShadow.querySelector('.lbl');
      if (existing && existing.textContent === label) return;
      paintShadowLabel(host.__buyNowShadow, label, arabic);
      return;
    }

    // Absolute last resort: light-DOM overlay
    var fallback = btn.querySelector('.buy-now-label');
    if (!fallback) {
      fallback = document.createElement('span');
      fallback.className = 'buy-now-label';
      fallback.setAttribute('translate', 'no');
      fallback.style.cssText =
        'position:absolute;inset:0;display:flex;align-items:center;justify-content:center;' +
        'font-size:14px;line-height:1.2;color:#000;pointer-events:none;z-index:5;' +
        (arabic ? "font-family:'Noto Kufi Arabic',sans-serif;letter-spacing:0;" : '');
      btn.appendChild(fallback);
    }
    fallback.textContent = label;
  }

  function fixBuyNowButtons() {
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(ensureBuyNowLabel);
  }

  function boot() {
    fixBuyNowButtons();

    if (!window.__buyNowObserver) {
      var timer;
      window.__buyNowObserver = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(fixBuyNowButtons, 60);
      });
      var root = document.querySelector('.buy_Block, product-form, .product-form__buttons') || document.body;
      window.__buyNowObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    setTimeout(fixBuyNowButtons, 250);
    setTimeout(fixBuyNowButtons, 1000);
    setTimeout(fixBuyNowButtons, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('theme:scripts:loaded', fixBuyNowButtons);
})();
